import {
  SeverityLevel,
  type ApplicationInsights,
  type IDependencyTelemetry,
} from '@microsoft/applicationinsights-web';
import { LogLevel } from '../enums/log-level.enum';
import { variables } from './../../variables';

//export let Logger_ai: ApplicationInsights;
class Logger {
  private minLevelForConsole: LogLevel;
  private minLevelForUpload: LogLevel;
  private aiInstance?: ApplicationInsights;

  constructor() {
    if (variables?.DEBUG_MODE && variables?.DEBUG_MODE != 'false') {
      console.log('Logger is in debug mode');
      this.minLevelForConsole = LogLevel.Verbose;
      this.minLevelForUpload = LogLevel.None;
    } else {
      this.minLevelForConsole = LogLevel.Warn;
      this.minLevelForUpload = LogLevel.Info;
    }
  }

  setAppInsights(ai: ApplicationInsights): void {
    this.aiInstance = ai;
  }

  debug(msg: string, details?: any) {
    this.writeToLog(msg, LogLevel.Debug, details);
  }

  info(msg: string, details?: any) {
    this.writeToLog(msg, LogLevel.Info, details);
  }

  warn(msg: string, details?: any) {
    this.writeToLog(msg, LogLevel.Warn, details);
  }

  error(msg: string, details?: any) {
    this.writeToLog(msg, LogLevel.Error, details);
  }

  log(msg: string, details?: any) {
    this.writeToLog(msg, LogLevel.Verbose, details);
  }

  trackDependency(dep: IDependencyTelemetry) {
    if (this.aiInstance) {
      this.aiInstance.trackDependencyData(dep);
    }
  }

  trackEvent(name: string, properties?: { [key: string]: any }) {
    if (this.aiInstance) {
      this.aiInstance.trackEvent({
        name: name,
        properties: properties,
      });
    }
  }

  private writeToLog(msg: string, level: LogLevel, details?: any) {
    if (
      this.minLevelForConsole !== LogLevel.None &&
      level >= this.minLevelForConsole
    ) {
      let value: string = LogLevel[level] + ': ' + msg;

      console.log(value + ' - ', details);
    }

    if (
      this.aiInstance &&
      this.minLevelForUpload !== LogLevel.None &&
      level >= this.minLevelForUpload
    ) {
      try {
        if (details) {
          this.aiInstance.trackTrace({
            message: msg + ' | ' + JSON.stringify(details),
            severityLevel:
              level == LogLevel.Error
                ? SeverityLevel.Error
                : level == LogLevel.Warn
                  ? SeverityLevel.Warning
                  : level == LogLevel.Info
                    ? SeverityLevel.Information
                    : SeverityLevel.Verbose,
          });
        } else {
          this.aiInstance.trackTrace({
            message: msg,
            severityLevel:
              level == LogLevel.Error
                ? SeverityLevel.Error
                : level == LogLevel.Warn
                  ? SeverityLevel.Warning
                  : level == LogLevel.Info
                    ? SeverityLevel.Information
                    : SeverityLevel.Verbose,
          });
        }
      } catch (e) {
        console.dir(e);
      }
    }
  }
}

export const defaultLogger: Logger = new Logger();
